export default __webpack_public_path__ + "static/media/KR Composites.1108eb97.png";